import { render } from "./product-sale-badge.vue?vue&type=template&id=65bd4d52"
import script from "./product-sale-badge.vue?vue&type=script&lang=js"
export * from "./product-sale-badge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__